let authToken = sessionStorage.getItem('authToken');
const refreshToken = sessionStorage.getItem('refreshToken');
if (authToken) {
    const tokenPayload = authToken.split('.')[1];
    const decodedPayload = atob(tokenPayload);
    var userDetails = JSON.parse(decodedPayload);
}

export { authToken, refreshToken };
export default userDetails;


export const getDiscountedPrice = (mrp, discountPercent) => {
    return mrp - (mrp * (discountPercent / 100));
};

export const getUserFromToken = () => {
    const token = sessionStorage.getItem("authToken");

    if (!token) return null;

    try {
        const payload = token.split(".")[1];
        const decoded = JSON.parse(atob(payload));

        return decoded;
    } catch (error) {
        return null;
    }
};